import { useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Returns today's room creation count from the dailyStats collection.
 * Uses a real-time Firestore listener so the count updates live.
 *
 * @returns {{ count: number|null, loading: boolean, error: boolean }}
 */
export function useDailyRoomStats() {
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD"
    const ref = doc(db, "dailyStats", today);

    const unsubscribe = onSnapshot(
      ref,
      (snap) => {
        if (snap.exists()) {
          setCount(snap.data().gamesCreated ?? 0);
        } else {
          setCount(0);
        }
        setLoading(false);
      },
      () => {
        // Silently fail — stats are non-critical
        setError(true);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return { count, loading, error };
}
